"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _vars = _interopRequireDefault(require("../../constants/vars"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tfont-family: ", ";\n\tbackground: ", ";\n\tborder: ", " solid\n\t\t", ";\n\tborder-radius: ", ";\n\tpadding: 0.5rem 1rem;\n\tmargin: 0.5rem 0rem;\n\twidth: ", ";\n\tcolor: ", "\n\tcursor: ", "\n\n\t&:focus {\n\t\tborder-color: ", ";\n\t\tbox-shadow: ", ";\n\t\toutline: 0;\n\t}\n\n\t&::placeholder {\n\t\tfont-family: ", ";\n\t\tcolor: ", ";\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var TextArea = _styledComponents.default.textarea(_templateObject(), _vars.default.fontStackBold, function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? '#f6f7fa' : 'white';
}, _vars.default.borderWidth, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? _colors.default.disabledOutline : _colors.default.borderColor;
}, _vars.default.borderRadius, function (_ref3) {
  var fullWidth = _ref3.fullWidth;
  return fullWidth ? '100%' : 'auto !important';
}, function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled ? _colors.default.grey : _colors.default.textColor;
}, function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled ? 'not-allowed' : 'default';
}, _colors.default.borderFocus, _vars.default.boxShadow, _vars.default.fontStackNormal, _colors.default.placeholder);

TextArea.displayName = 'TextArea';

var Textarea = function Textarea(_ref6) {
  var name = _ref6.name,
      props = _objectWithoutPropertiesLoose(_ref6, ["name"]);

  return _react.default.createElement(TextArea, _extends({
    name: name
  }, props));
};

Textarea.displayName = 'Textarea';
Textarea.propTypes = {
  name: _propTypes.string.isRequired,
  fullWidth: _propTypes.bool
};
Textarea.defaultProps = {
  fullWidth: false
};
var _default = Textarea;
exports.default = _default;